import React from "react";
import { CircularProgress, Backdrop } from "@material-ui/core";
import { useLoading } from "../constant/LoadingContext";

const LoadingComponent = () => {
  const { loading } = useLoading();

  return (
    <Backdrop open={loading} style={{ zIndex: 9999, color: "#fff" }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingComponent;
